import { render } from "./payment.vue?vue&type=template&id=40b5a7a5"
const script = {}

import exportComponent from "D:\\Work\\code\\Dataleading3.0\\dataleading\\app\\app-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__